import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Dashboard",
    component: () =>
      import(/* webpackChunkName: "dashboard" */ "@/components/Principal"),
    meta: {
      isPublic: false,
    },
  },
  // {
  //   path: "/Administrador",
  //   name: "Administrador",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "dashboard" */ "@/components/Administrador"
  //     ),
  //   meta: {
  //     isPublic: false,
  //   },
  // },
];

const router = new VueRouter({
  routes,
});

export default router;
